import { LoadingButton } from '@mui/lab';
import { Button, Typography } from '@mui/material';
import Dialog from 'components/dialog/dialog';
import { useRevokeSessionMutation } from 'app/store';
import { immediateToast } from 'utils/toast';
import { useState } from 'react';

export const RevokeSessionDialogue = ({
    id,
    ipAddress,
    onDeleted,
}: {
    id: string;
    ipAddress: string;
    onDeleted?: () => any;
}) => {
    const [open, setOpen] = useState(false);
    const [revokeSession, { isLoading }] = useRevokeSessionMutation();

    const handleClose = () => {
        if (!isLoading) setOpen(false);
    };

    const handleDelete = async () => {
        try {
            await revokeSession({ token_id: id }).unwrap();

            immediateToast('success', {
                message: 'نشست با موفقیت حذف شد',
                timeout: 2000,
            });

            setOpen(false);
            await onDeleted?.();
        } catch (error: any) {
            immediateToast('error', {
                message:
                    error?.data?.message ||
                    'حذف نشست انجام نشد. دوباره تلاش کنید.',
                timeout: 3000,
            });
        }
    };

    return (
        <>
            <Button
                variant="text"
                color="error"
                onClick={() => setOpen(true)}
                disableRipple
                sx={{ minWidth: 0 }}
            >
                حذف نشست
            </Button>

            <Dialog
                type="error"
                icon={<i className="fa-light fa-trash-can" />}
                open={open}
                onClose={handleClose}
                disable={isLoading}
                width="370px"
                label="حذف نشست"
            >
                <Typography
                    sx={{
                        color: 'text.secondary',
                        fontSize: 13,
                        lineHeight: 2,
                        textAlign: 'center',
                        px: 0.5,
                    }}
                >
                    {`آیا از حذف نشست با آی‌پی «${ipAddress}» اطمینان دارید؟`}
                </Typography>

                <LoadingButton
                    fullWidth
                    loading={isLoading}
                    sx={{
                        mt: 2.5,
                        minHeight: 40,
                        color: '#fff !important',
                        '&.Mui-disabled': {
                            color: 'rgba(255,255,255,.65) !important',
                        },
                    }}
                    variant="contained"
                    color="error"
                    onClick={handleDelete}
                >
                    تایید و حذف نشست
                </LoadingButton>
            </Dialog>
        </>
    );
};
